import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { useLocation } from 'react-router-dom';

import {
  createFormValidationFn,
  createInitialValues,
} from 'client/helpers/formikHelpers';

import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';
import SrFormikField, {
  SR_FIELD_THEME_WHITNEY,
} from 'client/components/SrFormikField';
import SrStaticFooter, {
  SR_STATIC_FOOTER_THEME_BUYER_AGENT_FORM_PAGE,
} from 'client/components/SrStaticFooter';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrErrorMessage from 'client/components/SrErrorMessage/SrErrorMessage';

const SrBuyerSideAgentFormPage = ({
  pageTitle,
  pageDescription,
  formFields,
  footerComponent,
  apiState,
  onSubmit,
}) => {
  const location = useLocation();

  const errorMessage = apiState.error && (
    (apiState.error.constraint === 'users_phone_unique'
      && 'There is already an account with that phone number.')
    || (apiState.error.constraint === 'users_email_unique'
      && 'There is already an account with that email.')
    || apiState.error.message
  );

  return (
    <div className='page-start'>
      <div className='startTouring'>
        <div className='progressBarContainer'>
          <div className='progressBar' style={{ width: '40%' }} />
        </div>
        <Navbar
          redirectLogoTo='/'
          leftButton={(
            <SrLink
              className='link back'
              to={`/get-started${location.search}`}
              restoreScrollPosition
              redirectToLastLocation
            />
          )}
        />
        <div className='stepContainer'>
          <Formik
            initialValues={createInitialValues({ formFields })}
            validate={createFormValidationFn(formFields)}
            onSubmit={onSubmit}
            render={(formikBag) => (
              <Form>
                <SrBox height='14px' />
                <h1>{pageTitle}</h1>
                {pageDescription && (
                  <SrBox margin='20px 0 16px'>
                    <SrText
                      color='grey'
                      weight='500'
                      lineHeight='25px'
                    >
                      {pageDescription}
                    </SrText>
                  </SrBox>
                )}
                <SrBox marginBottom='60px'>
                  {formFields.map((formField) => (
                    <SrFormikField
                      formField={formField}
                      formikBag={formikBag}
                      theme={SR_FIELD_THEME_WHITNEY}
                      key={formField.id}
                    />
                  ))}
                </SrBox>
                <SrStaticFooter theme={SR_STATIC_FOOTER_THEME_BUYER_AGENT_FORM_PAGE}>
                  <ButtonDeprecated
                    type='submit'
                    disabled={apiState.inProgress}
                  >
                    next
                  </ButtonDeprecated>
                  {footerComponent}
                </SrStaticFooter>
                {errorMessage && (
                  <SrBox
                    marginTop='10px'
                    borderRadius='3px'
                  >
                    <SrErrorMessage>
                      {errorMessage}
                    </SrErrorMessage>
                  </SrBox>
                )}
              </Form>
            )}
          />
        </div>
      </div>
    </div>
  );
};

SrBuyerSideAgentFormPage.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  pageDescription: PropTypes.string.isRequired,
  formFields: PropTypes.array.isRequired,
  footerComponent: PropTypes.node,
  apiState: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

SrBuyerSideAgentFormPage.displayName = 'SrBuyerSideAgentFormPage';

export default SrBuyerSideAgentFormPage;
